import React from 'react';

// From https://loading.io/css/
// It's 64px by default. If you need a different size, scale using CSS, e.g. transform:scale(0.5)

const Spinner = () => {
    return (
        <div className="lds-roller spinner">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>
    );
};

export default React.memo(Spinner);
